import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';

import { EventApi, EventCategoryApi } from "../../../services/webservice";
import { EventActions, EventCategoryActions } from "../../../actions"
import { MerchantActions } from '../../merchants/merchant.actions';

@Injectable()
export class EventFormResolver implements Resolve<any> {

	constructor(
		private store: Store<AppState>,
		private eventActions: EventActions,
		private eventApi: EventApi,
		private eventCategoryApi: EventCategoryApi,
		private eventCategoryActions: EventCategoryActions,
		private merchantActions: MerchantActions,
	) { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		this.store.dispatch(this.eventActions.clearState());
		if (route.params["id"]) {
			this.eventApi.getEventById(route.params["id"]).subscribe(event => {
				this.store.dispatch(this.eventActions.eventLoaded(event))
				this.eventCategoryApi.getEventCategory(event._links.eventCategory.href).subscribe(eventCategory => {
					this.store.dispatch(this.eventCategoryActions.eventCategoryLoaded(eventCategory))
				});
			this.store.dispatch(this.merchantActions.loadMerchantByMerchantId(event.merchantId));
			});
		} else {
			this.store.dispatch(this.eventActions.eventLoaded(null))
			this.store.dispatch(this.eventCategoryActions.eventCategoryLoaded(null))
			this.store.dispatch(this.merchantActions.merchantLoaded(null));
		}

		this.eventCategoryApi.getAssignableEventCategories().subscribe(eventCategories => {
			eventCategories.sort((a,b) => a.fullDescription.localeCompare(b.fullDescription));
			this.store.dispatch(this.eventCategoryActions.eventCategoriesLoaded(eventCategories))
		})
	}

}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-form/event-form.resolver.ts